/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "120e3d9888eeca5e11222e569a75356f06aa2284";
